export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const APP_RELEASE_DATE = process.env.REACT_APP_APP_RELEASE_DATE;
export const ROOT_API = process.env.REACT_APP_ROOT_API;
export const ROOT_WEB = process.env.REACT_APP_ROOT_WEB;
export const IS_PROD_ENV = process.env.NODE_ENV === 'production';
export const IS_DEV_ENV = process.env.NODE_ENV === 'development';
